import { Avatar, Box, IconButton, Modal, Typography, useMediaQuery } from '@mui/material';
import React, { useState, useEffect } from 'react';
import homeBg from '../../Assets/homebG.png';
import logo from '../../Assets/in5-logo.png';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { makeStyles } from '@mui/styles';
import { useHistory } from 'react-router-dom';
import { getFirstLetters } from '../../Helpers/helper';
import Notifications from '../Notification';
import LogoutIcon from '@mui/icons-material/Logout';
import  storageService  from '../../../../Utils/storageService';

const useStyles = makeStyles(() => ({
  headerContainer: {
    border: '1.33px solid #E6E6E6',
    borderRadius: '10px',
    padding: '10px',
    background: '#FFFFFF',
    '@media (max-width: 600px)': {
      border: 'none',
      padding: '0px',
      background: 'transparent',
    },
  },
  brandLogo: {
    height: '50px',
    width: 'auto',
    marginLeft: '20px',
    '@media (max-width: 600px)': {
      height: '25px',
      width: 'auto',
      marginLeft: '0px',
    },
    '@media (max-width: 1440px)': {
      height: '40px',
      width: 'auto',
    },
  },
  actionContainer: {
    border: '0.67px solid #E6E6E6',
    borderRadius: '16px',
    padding: '14px 24px',
    '@media (max-width: 600px)': {
      padding: '14px 0px',
    },
    '@media (max-width: 1440px)': {
      padding: '6px 14px',
    }

  },
  notificationContainer: {
    width: '400px',
    position: 'absolute',
    right: '8%',
    top: '12%',
    height: '400px',
    borderRadius: '8px',
    overflow: 'auto',
    background: '#fff',
  },
  logoutBtn: {
    cursor: 'pointer',
    background: '#D1C8E3',
    padding: '8px 12px',
    borderRadius: '8px',
  },
  logoutText: {
    fontSize: '10px !important',
    fontWeight: '500 !important',
    color: '#3A2B5B !important',
  },
  logoutIcon: {
    color: '#000000',
    height: '14px',
    width: 'auto',
  },
  userName: {
    fontSize: '12px !important',
    fontWeight: '600 !important',
    color: '#333333 !important',
    '@media (min-width: 1920px)': {
      fontSize: '16px !important',
    },
  },
  userId: {
    fontSize: '12px !important',
    fontWeight: '400 !important',
    color: '#909090 !important',
    '@media (min-width: 1920px)': {
      fontSize: '16px !important',
    },
  },
}));

export const Header: React.FunctionComponent = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width:600px)');
  const [user, setUser] = useState<any>(null);
  const navigate = useHistory();
  const [open, setOpen] = useState<boolean>(false);
  const is1440 = useMediaQuery('(max-width:1440px)');
  
  useEffect(() => {
    const loadUserData = async () => {
      try {
        const userData = await storageService.getItem('user');
        setUser(userData ? JSON.parse(userData) : null);
      } catch (error) {
        console.error('Error loading user data:', error);
        setUser(null);
      }
    };
    loadUserData();
  }, []);
  
  const handleToggleDialog = () => {
    setOpen(!open);
  };

  return (
    <>
      <Modal
        onClose={() => {
          handleToggleDialog();
        }}
        open={open}
        slotProps={{
          backdrop: {
            style: {
              opacity: 0.5,
            },
          },
        }}
      >
        <Box component={'div'} className={classes.notificationContainer}>
          {/* <Notifications /> */}
        </Box>
      </Modal>
      <Box component={'div'} className="h-100 w-100 d-flex flex-column" gap={'12px'}>
        <Box component={'div'} className={`d-flex justify-content-between align-items-center w-100 ${classes.headerContainer}`}>
          <img src={logo} className={classes.brandLogo} />
          <Box component={'div'} className={`d-flex align-items-center ${classes.actionContainer}`} gap={'10px'}>
            {/* <IconButton
              onClick={() => {
                if (isMobile) {
                  navigate.push('/notification');
                } else {
                  handleToggleDialog();
                }
              }}
            >
              <NotificationsNoneOutlinedIcon sx={{ color: '#665097', height: isMobile ? '16px' : '32px' }} />
            </IconButton> */}
            <IconButton
              onClick={() => {
                navigate.push('/schedules');
              }}
            >
              <CalendarTodayOutlinedIcon sx={{ color: '#665097', height: isMobile ? '16px' : is1440 ? '22px' : '32px' }} />
            </IconButton>
            {isMobile ? (
              <Avatar sx={{ background: '#F6F8FB', color: '#604797', border: '0.5px solid #00000033', fontSize: '16px', fontWeight: '600' }}>{getFirstLetters(user?.userName)}</Avatar>
            ) : (
              <Box component={'div'} className="d-flex align-items-center" gap={'13px'}>
                <Avatar sx={{ background: '#F6F8FB', color: '#604797', border: '0.5px solid #00000033', fontSize: is1440 ? '12px' : '16px', fontWeight: '600', height: is1440 ? '30px' : "40px", width: is1440 ? '30px' : "40px" }}>{getFirstLetters(user?.userName)}</Avatar>
                <Box component={'div'} className="d-flex flex-column gap-1">
                  <Typography className={classes.userName}>{user?.userName}</Typography>
                  <Typography className={classes.userId}>{user?.userEmail}</Typography>
                </Box>
              </Box>
            )}
            <Box
              component={'div'}
              className={`d-flex align-items-center gap-2 ${classes.logoutBtn}`}
              onClick={async () => {
                await storageService.clear();
                navigate.push('/');
              }}
            >
              <Typography className={classes.logoutText}>Logout</Typography>
              <LogoutIcon className={classes.logoutIcon} />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

const AppLayout: React.FunctionComponent<any> = ({ children }) => {
  const isMobile = useMediaQuery('(max-width:600px)');

  return (
    <Box component={'section'} style={{ minHeight: '100vh', width:isMobile ? '' : '100vw', background: `transparent` }} className="scrollbar-hide">
      <img src={homeBg} style={{ position: 'absolute', height: '100vh', width: '100%', zIndex: '-1' }} />
      <Box component={'div'} className="d-flex flex-column gap-3" padding={isMobile ? '0px' : '30px'}>
        {/* <Header /> */}
        {children}
      </Box>
    </Box>
  );
};

export default AppLayout;
